import { ImpuestoEmpresaReadingDtoProps } from "api/DTOs/ImpuestoEmpresaReadingDto"
import { TIPO_GRUPO_IMPUESTO } from "api/Types/TipoGrupoImpuesto"

export const TaxValue = (rowData: ImpuestoEmpresaReadingDtoProps) => {
  return (
    <div
      className={`tw-text-right ${
        rowData?.grupoImpuesto?.tipoGrupoImpuesto ===
        TIPO_GRUPO_IMPUESTO?.IMPUESTO_REPERCUTIDO
          ? "!tw-text-secondary-75"
          : "!tw-text-danger-20"
      }`}
    >
      {`${rowData?.valor} %`}
    </div>
  )
}
